import { render, staticRenderFns } from "./_product-roles.vue?vue&type=template&id=00a2490f"
import script from "./_product-roles.vue?vue&type=script&lang=js"
export * from "./_product-roles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports